/** @griffel:css-start [d] null **/
.f2qykdt{--fui-Drawer--size:min(100vw, max(50vw, 480px));}
.f921z2{max-inline-size:100vw;}
.f2qykdt{--fui-Drawer--size:min(100vw, max(50vw, 480px));}
.f921z2{max-inline-size:100vw;}
.f1fcg080{padding-block-end:var(--spacingVerticalS);}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f1p2dij1{border-block-end-style:solid;}
.f1a566p{border-block-end-color:var(--colorNeutralStroke2);}
.fjksvth{overflow-wrap:anywhere;}
.f22iagw{display:flex;}
.f122n59{align-items:center;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.fqu8h5b{padding-block-start:var(--spacingVerticalL);}
.f1bxpd7w{display:contents;}
/** @griffel:css-end **/